import React from 'react';
import { createLanguageFilters, matchesLanguageCode } from '@utils/supportedLanguages';
import LanguageIcon from '@components/LanguageIcon';
import PublishedStatusIcon from '@components/PublishedStatusIcon';
import { trimTextToApproximateLength } from '@utils';

export default (t, formTranslationKey) => [
  {
    className: 'language-column',
    title: t('cards:FormList.columns.language.title'),
    dataIndex: 'language',
    key: 'language',
    render: language => {
      return <LanguageIcon language={language} />;
    },
    filters: createLanguageFilters(t),
    onFilter: (value, record) => matchesLanguageCode(record.language, value),
    width: 125,
  },
  {
    title: t(`cards:FormList.columns.${formTranslationKey}.title`),
    dataIndex: 'name',
    key: 'title',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 300,
  },
  {
    title: t('cards:FormList.columns.description'),
    dataIndex: 'description',
    key: 'description',
    render: description => trimTextToApproximateLength(description),
    sorter: (a, b) => a.description.localeCompare(b.description),
    width: 350,
  },
  {
    title: t('cards:FormList.columns.audience.title'),
    dataIndex: 'audienceType',
    key: 'audienceType',
    width: 150,
    render: at => t(`common:audienceType:${at}`),
    filters: [
      {
        text: t('common:audienceType.app-user'),
        value: 'app-user',
      },
      {
        text: t('common:audienceType.clinician'),
        value: 'clinician',
      },
    ],
    onFilter: (value, record) => record.audienceType === value,
  },
  {
    title: t('cards:FormList.columns.mode.title'),
    dataIndex: 'latestVersion',
    key: 'latestVersion.url',
    render: latestVersion => {
      const displayMode = latestVersion.uiSchema['ui:displayMode'];
      const displayModeToTranslationKey = {
        standard: 'cards:FormList.columns.mode.standard',
        paginated: 'cards:FormList.columns.mode.paginated',
        chat: 'cards:FormList.columns.mode.chat',
      };
      const translationKey =
        displayModeToTranslationKey[displayMode] || 'cards:FormList.columns.mode.standard';
      return t(translationKey);
    },
    filters: [
      {
        text: t('cards:FormList.columns.mode.standard'),
        value: 'standard',
      },
      {
        text: t('cards:FormList.columns.mode.paginated'),
        value: 'paginated',
      },
      {
        text: t('cards:FormList.columns.mode.chat'),
        value: 'chat',
      },
    ],
    onFilter: (value, record) => record.latestVersion.uiSchema['ui:displayMode'] === value,
    width: 150,
  },

  {
    className: 'published-column',
    title: t('cards:FormList.columns.published.title'),
    dataIndex: 'published',
    key: 'published',
    render: published => <PublishedStatusIcon published={published} />,
    filters: [
      {
        text: t('cards:FormList.columns.published.published'),
        value: true,
      },
      {
        text: t('cards:FormList.columns.published.unpublished'),
        value: false,
      },
    ],
    onFilter: (value, record) => record.published === value,
    width: 155,
  },
];
